import React, { useState } from 'react';
import classNames from 'classnames';
import { IconButton } from '@material-ui/core';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';

import cn from './MaskedContent.module.scss';

export const MaskedContent = ({ content, className }) => {
  const [hidden, setHidden] = useState(true);

  const maskedValue = (new Array(content.toString().length))
    .fill(<>&lowast;</>);

  return (
    <div className={classNames(cn.maskedContent, className)}>
      <span
        className={classNames({[cn.maskedValue]: hidden})}
      >
        {hidden ? maskedValue : content}
      </span>
      <IconButton
        className={cn.iconButton}
        onClick={() => setHidden(!hidden)}
      >
        {hidden ? (
          <VisibilityIcon color="action" />
        ) : (
          <VisibilityOffIcon color="action"/>
        )}
      </IconButton>
    </div>
  )
}
